export const SERVICE_TYPES = [
  { value: 'DR', label: 'DR (Desratización)' },
  { value: 'DS', label: 'DS (Desinsectación)' },
  { value: 'SN', label: 'SN (Sanitización)' },
  { value: 'CP', label: 'Control de palomas' },
  { value: 'OTROS_SERVICIOS', label: 'Otros servicios' }
]

export const SERVICE_FREQUENCIES = [
  { value: 1, label: 'Semanal' },
  { value: 2, label: 'Quincenal' },
  { value: 3, label: 'Mensual' },
  { value: 4, label: 'Bimensual' },
  { value: 5, label: 'Trimestral' },
  { value: 6, label: 'Esporádico' }
]

export const CORE_SERVICE_TYPES = ['DR', 'DS', 'SN', 'CP']
